import { render } from "./AskForNewPassword.vue?vue&type=template&id=0b52808e"
import script from "./AskForNewPassword.vue?vue&type=script&lang=js"
export * from "./AskForNewPassword.vue?vue&type=script&lang=js"

import exportComponent from "d:\\buildagent\\agent-cidev01-a\\205\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__